'use client';

import { ReactNode } from 'react';
import { useRouter } from 'next/navigation';
import { ButtonBase } from '../../common';
import { RegularArrowLeft } from '../../common/svgIcons';

type NavigationBackButtonProps = {
  handleVirtualNavigation?: () => void;
  isDisabled?: boolean;
  noPadding?: boolean;
  icon?: ReactNode;
};

const NavigationBackButton = ({
  handleVirtualNavigation,
  isDisabled,
  noPadding,
  icon,
}: NavigationBackButtonProps) => {
  const router = useRouter();

  const navigate = () => {
    if (handleVirtualNavigation) {
      handleVirtualNavigation();
    } else {
      router.back();

      router.refresh();
    }
  };

  return (
    <ButtonBase
      onClick={navigate}
      disabled={isDisabled}
      noPadding={noPadding}
      visual="ghost"
      size="small"
      aria-label="navigation back button"
      data-testid="navigation-back-button"
    >
      {icon || <RegularArrowLeft size={24} data-dir="rtl" />}
    </ButtonBase>
  );
};

export { NavigationBackButton };
